import AiDocumentUploadForm from './AiDocumentUploadForm'

export default AiDocumentUploadForm
